import { render, staticRenderFns } from "./v-sort-tables.vue?vue&type=template&id=451fac2b&scoped=true&"
import script from "./v-sort-tables.vue?vue&type=script&lang=js&"
export * from "./v-sort-tables.vue?vue&type=script&lang=js&"
import style0 from "./v-sort-tables.vue?vue&type=style&index=0&id=451fac2b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "451fac2b",
  null
  
)

export default component.exports